import styled from 'styled-components';

import { motion } from 'framer-motion';

export const Wrapper = styled.div`
  position: absolute;
  bottom: 32px;
  left: 0;
`;

export const Container = styled(motion.div)`
  width: 454px;

  display: flex;
  align-items: flex-start;
  gap: 12px;

  padding: 16px;

  position: relative;
  z-index: 100;

  /* danger-50 */
  background-color: #fff5f5;

  margin-bottom: 16px;
  margin-left: 16px;
  /* danger-500 */
  border: 1px solid #e53e3e;
  border-radius: 8px;

  svg {
    flex-shrink: 0;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Title = styled.h2`
  /* danger-700 */
  color: #9b2c2c;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 24px */
`;

export const Description = styled.p`
  /* danger-700 */
  color: #9b2c2c;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: transparent;
  border: 0;
  padding: 0;
  margin-left: auto;

  cursor: pointer;
`;
